import { jss } from '.'

//By decreasing the specificity we prevent child's styles from overriding custom styles passed by parent
let specificity = 100000

export const createSheet = styles => {
    const sheet = jss.createStyleSheet(styles, { index: specificity--, link: true })
    return sheet
}